import { omit } from 'lodash'

// Types
import { QueryObject, SearchConfig } from 'types'

type UpdateSearchQithQuery = (query: QueryObject) => void

export const handleListItemUpdate =
  (key: string, currentQuery: QueryObject, updateSearchWithQuery: UpdateSearchQithQuery) =>
  (id: number): void => {
    const { genres, regions, keys, types, categories, ...queryWithoutKeyParam } = currentQuery

    let keyData = currentQuery[key as keyof typeof currentQuery] as number[]
    if (keyData && keyData.includes(id)) {
      keyData = keyData.filter(keyId => keyId !== id)
    } else {
      keyData = keyData ? [...keyData, id] : [id]
    }
    updateSearchWithQuery({
      ...queryWithoutKeyParam,
      ...(genres && key !== 'genres' ? { genres } : {}),
      ...(regions && key !== 'regions' ? { regions } : {}),
      ...(keys && key !== 'keys' ? { keys } : {}),
      ...(types && key !== 'types' ? { types } : {}),
      ...(categories && key !== 'categories' ? { categories } : {}),
      ...(keyData && keyData.length ? { [key]: keyData } : {}),
    })
  }

export const handleSliderUpdate =
  (key: string, currentQuery: QueryObject, searchConfig: SearchConfig, updateSearchWithQuery: UpdateSearchQithQuery) =>
  (newValues: readonly number[]): void => {
    if (key === 'bpm') {
      const { bpm_under, bpm_over, ...queryWithoutKeyParams } = currentQuery // eslint-disable-line
      const [new_bpm_over, new_bpm_under] = newValues
      updateSearchWithQuery({
        ...queryWithoutKeyParams,

        ...(searchConfig && new_bpm_over !== searchConfig.min_bpm.value ? { bpm_over: new_bpm_over } : {}),
        ...(searchConfig && new_bpm_under !== searchConfig.max_bpm.value ? { bpm_under: new_bpm_under } : {}),
      })
    } else if (key === 'release_year') {
      const { release_year_before, release_year_after, ...queryWithoutKeyParams } = currentQuery // eslint-disable-line
      const [new_release_year_after, new_release_year_before] = newValues
      const minYear = searchConfig ? searchConfig.min_year.value : 0
      const maxYear = searchConfig ? searchConfig.max_year.value : 0

      updateSearchWithQuery({
        ...queryWithoutKeyParams,
        ...(searchConfig && new_release_year_after !== minYear ? { release_year_after: new_release_year_after } : {}),
        ...(searchConfig && new_release_year_before !== maxYear ? { release_year_before: new_release_year_before } : {}),
      })
    }
  }

export const handleClearSpecificFilter =
  (key: string, currentQuery: QueryObject, updateSearchWithQuery: UpdateSearchQithQuery) => (): void => {
    if (key === 'bpm') {
      updateSearchWithQuery(omit(currentQuery, 'bpm_over', 'bpm_under'))
    } else if (key === 'release_year') {
      updateSearchWithQuery(omit(currentQuery, 'release_year_before', 'release_year_after'))
    } else {
      updateSearchWithQuery(omit(currentQuery, key, key === 'types' ? 'multitrack' : ''))
    }
  }
